export function LoadingScreen() {
  return <div className="form-screen">Loading...</div>;
}
